export default __webpack_public_path__ + "static/EconSansBol-1fbdf21e384399e27ead0ea33468b6ba.woff2";